// ČESKÁ REALITNÍ — Homepage Hero JS.
//
// Funkce:
//   1. Scroll affordance visibility: IntersectionObserver skryje chevron,
//      jakmile uživatel odscrolluje pryč z Hero sekce (fade-in přes CSS po loadu).
//
// Selektory přes data-* atributy (CB-safe — editor je při editaci textu nesmaže).
// Žádné jQuery, žádné IIFE — top-level const scope je v pořádku (Babel transpile).

const initCeskaHero = (root) => {
    const scrollAffordance = root.querySelector('.Hero-scroll');
    if (!scrollAffordance) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Zobrazit scroll affordance po loadu (opacity: 0 v CSS, fade-in zde).
    if (!reduceMotion) {
        scrollAffordance.style.transition = 'opacity .6s ease';
        scrollAffordance.style.opacity = '1';
    } else {
        scrollAffordance.style.opacity = '1';
    }

    // Skrýt scroll affordance, jakmile uživatel odscrolluje pryč z Hero.
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!reduceMotion) {
                        scrollAffordance.style.opacity = entry.isIntersecting ? '1' : '0';
                    }
                });
            },
            { threshold: 0.2 }
        );
        observer.observe(root);
    }
};

const bootCeskaHero = () => {
    document.querySelectorAll('[data-ceska-hero]').forEach(initCeskaHero);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCeskaHero);
} else {
    bootCeskaHero();
}
